/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./settingDialog.vue?vue&type=template&id=5395d6e0&scoped=true&"
import script from "./settingDialog.vue?vue&type=script&lang=js&"
export * from "./settingDialog.vue?vue&type=script&lang=js&"
import style0 from "./settingDialog.vue?vue&type=style&index=0&id=5395d6e0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395d6e0",
  null
  
)

export default component.exports